import React from 'react';
import { ErrorMessage } from 'formik';
import { ErrorMessage as StyledErrorMessage, ErrorMessageProps } from 'src/kit';

export type FormikErrorMessageProps = ErrorMessageProps & { name: string };
export const FormikErrorMessage = ({ name, ...styledProps }: FormikErrorMessageProps) => (
  <ErrorMessage name={name}>
    {errorMessage => <StyledErrorMessage {...styledProps}>{errorMessage}</StyledErrorMessage>}
  </ErrorMessage>
);

export default FormikErrorMessage;
